/**
 * Created by afuhr on 20.06.2016.
 */
import {Pipe, PipeTransform} from "@angular/core";
import {StockItem} from "../../shared/view-model/store-management/stock-item.type";
import {StockProperty} from "../../shared/view-model/store-management/stock-property.type";

@Pipe({name: 'stockName'})
export class StockNamePipe implements PipeTransform {

  transform(stockItem: StockItem): string {

    if (!stockItem) {
      return "";
    }

    if (!stockItem.properties) {
      return stockItem.name;
    }

    return stockItem.name + StockNamePipe.getPropertyLabelAppendix(stockItem);
  }

  public static getPropertyLabelAppendix(stockItem: StockItem): string {

    if (!stockItem) {
      return "";
    }

    if (!stockItem.properties) {
      return stockItem.name;
    }

    let app: string = "";
    stockItem.properties.forEach(p => {
      app += ', ' + p.name + ' ' + p.value
    });
    return app;
  }

  public static getPropertiesLabel(properties: StockProperty[]): string {
    if (!properties) {
      return "";
    }

    let app: string = "";
    properties.forEach((p: any) => {
      app += ', ' + (p.name ? p.name : p.property_name) + ' ' + p.value
    });

    return app;
  }
}



// WEBPACK FOOTER //
// ./src/app/store-management/stock-item/stock-name.pipe.ts